import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./SinglePostCard.scss";
import isEqual from "react-fast-compare";
import moment from "moment";
import Image from "antd/lib/image";
import Tooltip from "antd/lib/tooltip";
import Popover from "antd/lib/popover";

import verified from "../../../../../../assets/verified.svg";
import BoostedPostIcon from "../../../../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../../../../assets/ads_post_icon.svg";
import Profile from "../../../../../../assets/Profile_Pic.svg";
import userFollowers from "../../../../../../assets/FollowersBlue.svg";
import userFollowersDark from "../../../../../../assets/FollowersDark.svg";
import ClockIcon from "../../../../../../assets/Clock.svg";
import fx from "../../../../../../assets/WidgetMaker/FX.svg";
import fxDark from "../../../../../../assets/WidgetMaker/FX_Dark.svg";
import InfoIcon from "../../../../../../assets/Info_Icon.svg";
import InfoIconYellow from "../../../../../../assets/Info_Icon_Yellow.svg";

import placeHolderImg from "../../../../../../assets/placeholder_img.png";
import defaultImg from "../../../../../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../../../../../assets/brandLogos/Default_Brand.svg";

import { SocialMedialogo } from "../../../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import {
  getClass,
  isScontentLinkExpire,
  kFormatter,
} from "../../../../../../redux/constants";

import VideoPreview from "../../../../../WidgetMaker/VideoPreview";
import Carousel from "../../../../../WidgetMaker/Carousel";
import PostCardFooter from "../../../../../WidgetMaker/PostCardFooter";
import PostCardDetails from "../../../../../WidgetMaker/PostCardDetails";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
} from "../../../../../../redux/constants/enums";
import { useSelector } from "react-redux";

const SinglePostCard = ({
  postData,
  backgroundColor,
  color,
  arrowDirection,
  isDarkBackground,
  isTweetView,
  isTooltipShow,
  setIsTooltipShow,
  containerRef,
  PdfDownloadStatus,
  cardKey,
  hideHeaderOfCard,
  isCommandCenterScreen,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [isImage, setIsImage] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImage(true);
    } else {
      setIsImage(false);
    }
    return (e.target.src = defaultImg);
  };
  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };
  const showModal = (data) => {
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(data);
  };
  return (
    <>
      <div
        className={`node-modal-content SinglePostCard postCardDetails
          ${
            isDarkBackground
              ? `dark-theme ${isTweetView ? "" : "border border-color"}`
              : `${isTweetView ? "" : "border border-color"}`
          } ${
          isTweetView
            ? isDarkBackground
              ? "p-0 border-0 tweetCardView"
              : "p-0 border border-color tweetCardView"
            : ""
        }`}
        style={{
          backgroundColor: backgroundColor,
          backgroundColor: backgroundColor,
          borderColor: color,
        }}
        key={cardKey ? cardKey : "SinglePostCard"}
      >
        <div
          className={`node-modal-arrow ${arrowDirection}`}
          style={
            arrowDirection === "top"
              ? { borderTopColor: backgroundColor }
              : arrowDirection === "bottom"
              ? { borderBottomColor: backgroundColor }
              : arrowDirection === "right"
              ? { borderRightColor: backgroundColor }
              : arrowDirection === "left"
              ? { borderLeftColor: backgroundColor }
              : ""
          }
        ></div>
        {hideHeaderOfCard && postData?.SentimentType ? (
          <div
            className="SinglePostCard__sentiment--leftBorder"
            style={{
              borderColor: `${
                postData?.SentimentType === "Positive"
                  ? "#5ED142"
                  : postData?.SentimentType === "Negative"
                  ? "#FF5D48"
                  : postData?.SentimentType === "Neutral"
                  ? "#F0C52F"
                  : ""
              }`,
            }}
          ></div>
        ) : (
          ""
        )}
        <div
          className={`node-modal-header border-0 postCardDetails__header ${
            postData?.SentimentType ? "pl-0" : ""
          } ${hideHeaderOfCard ? "d-none" : ""} ${
            postCardUserbrandPrivateMessagesId?.includes(postData?.channel_type)
              ? getClass(authParams, "message")
              : postData?.PlatformID == 1 &&
                postData?.ParentSocialID !== "NA" &&
                postData?.ParentSocialID != 0 &&
                postData?.ParentSocialID !== ""
              ? getClass(authParams, "comment")
              : postCardUserBrandCommentId?.includes(postData?.channel_type) &&
                postData?.PlatformID != 1
              ? getClass(authParams, "comment")
              : getClass(authParams, "post")
          }`}
        >
          {postData?.SentimentType ? (
            <div
              style={{
                borderLeft: `0.4rem solid ${
                  postData?.SentimentType === "Positive"
                    ? "#5ED142"
                    : postData?.SentimentType === "Negative"
                    ? "#FF5D48"
                    : postData?.SentimentType === "Neutral"
                    ? "#F0C52F"
                    : "black"
                }`,
                height: "3.6rem",
                marginRight: "1rem",
              }}
            ></div>
          ) : (
            ""
          )}
          {postData?.brand_logo &&
          postData?.BrandFriendlyName &&
          postData?.BrandFriendlyName !== "NA" &&
          postData?.BrandFriendlyName !== "" ? (
            <Popover
              placement="leftBottom"
              title={null}
              content={
                <div
                  style={{
                    maxWidth: "25rem",
                    maxHeight: "15rem",
                    overflow: "auto",
                    overflowWrap: "break-word",
                  }}
                  className="postCardDetails--brandname p-10"
                >
                  {postData?.BrandFriendlyName}
                </div>
              }
              overlayClassName={`postCardDetails__popover ${
                isDarkBackground ? "darkTheme" : "lightTheme"
              }`}
            >
              <Image
                src={
                  postData?.brand_logo ? postData?.brand_logo : Default_Brand
                }
                fallback={Default_Brand}
                onError={getDefautBrandImg}
                preview={false}
                alt="Brand logo"
                className="authorImg authorImg--profile mr-1 cursor-pointer"
                // crossOrigin="anonymous"
              />
            </Popover>
          ) : (
            <Image
              src={postData?.brand_logo ? postData?.brand_logo : Default_Brand}
              fallback={Default_Brand}
              onError={getDefautBrandImg}
              preview={false}
              alt="Brand logo"
              className="authorImg authorImg--profile mr-1 cursor-pointer"
              // crossOrigin="anonymous"
            />
          )}

          <div
            className="position-relative mr-15"
            style={{ width: "3.5rem", height: "3.5rem" }}
          >
            <Popover
              placement="leftBottom"
              title={null}
              content={
                <div className="p-15 postCardDetails--bio">
                  {postData?.AuthorBio &&
                  postData?.AuthorBio !== "NA" &&
                  postData?.AuthorBio !== "" ? (
                    <div className="postCardDetails--bio--header font-weight500 w-100">
                      Bio
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    style={{
                      maxWidth: "25rem",
                      maxHeight: "15rem",
                      overflow: "auto",
                      overflowWrap: "break-word",
                    }}
                    className="custom_scroll1"
                  >
                    {postData?.AuthorBio &&
                    postData?.AuthorBio !== "NA" &&
                    postData?.AuthorBio !== "" ? (
                      <>{postData?.AuthorBio}</>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center w-100">
                        Bio not found
                      </div>
                    )}
                  </div>
                </div>
              }
              overlayClassName={`postCardDetails__popover ${
                isDarkBackground ? "darkTheme" : "lightTheme"
              }`}
            >
              <Image
                src={
                  postData?.ProfilePicture === 0 ||
                  postData?.ProfilePicture === "" ||
                  !postData?.ProfilePicture
                    ? Profile
                    : postData?.ProfilePicture
                }
                fallback={Profile}
                preview={false}
                alt="Profile Images"
                className="authorImg authorImg--profile mr-0"
              />
            </Popover>
          </div>
          <div style={{ flex: 1 }}>
            <div className="authorName d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Tooltip title={postData?.AuthorName}>
                  <span
                    className="text-ellipsis"
                    style={{
                      maxWidth:
                        (postData?.AuthorIsVerified !== "NA" &&
                          postData?.AuthorIsVerified &&
                          postData?.AuthorIsVerified > 0) ||
                        [1, 2]?.includes(postData?.isPromoted)
                          ? "15rem"
                          : "",
                    }}
                  >
                    {postData?.AuthorURL && postData?.AuthorURL !== "NA" ? (
                      <a
                        className={
                          postData?.AuthorURL && postData?.AuthorURL !== "NA"
                            ? ""
                            : "pointer-events1 cursor-default"
                        }
                        href={
                          postData?.AuthorURL && postData?.AuthorURL !== "NA"
                            ? postData?.AuthorURL
                            : ""
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        {postData?.AuthorName}
                      </a>
                    ) : (
                      <>{postData?.AuthorName}</>
                    )}
                  </span>
                </Tooltip>

                {postData?.AuthorIsVerified !== "NA" &&
                postData?.AuthorIsVerified &&
                postData?.AuthorIsVerified > 0 ? (
                  <img
                    src={verified}
                    alt="verified"
                    className="authorImg ml-1"
                    style={{ width: "1.5rem" }}
                  />
                ) : (
                  ""
                )}
                {postData?.isPromoted === 1 ? (
                  <Tooltip title="Boosted post">
                    <img
                      alt="Boosted Post Icon"
                      src={BoostedPostIcon}
                      className="mr-0"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                    />
                  </Tooltip>
                ) : postData?.isPromoted === 2 || postData?.isPromoted === 5 ? (
                  <Tooltip
                    title={
                      postData?.isPromoted === 5 ? "Dark Ad Post" : "Ad Post"
                    }
                  >
                    <img
                      alt="Ad Post Icon"
                      src={AdsPostIcon}
                      className="mr-0"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                    />
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
              <div className="position-relative">
                <img
                  src={
                    postData?.ChannelGroupId === 0 || postData?.PlatformID === 0
                      ? Default_Brand
                      : SocialMedialogo?.[postData?.ChannelGroupId]
                      ? SocialMedialogo?.[postData?.ChannelGroupId]
                      : SocialMedialogo?.[postData?.PlatformID]
                      ? SocialMedialogo?.[postData?.PlatformID]
                      : Default_Brand
                  }
                  style={{
                    width: "1.6rem",
                    maxHeight: "2rem",
                    // verticalAlign: "top",
                  }}
                  alt="channel icon"
                />
              </div>
            </div>

            <div
              className="authorScreenName"
              //style={{ maxWidth: "50%" }}
            >
              {postData?.AuthorURL && postData?.AuthorURL !== "NA" ? (
                <a
                  className={
                    postData?.AuthorURL && postData?.AuthorURL !== "NA"
                      ? ""
                      : "pointer-events1 cursor-default"
                  }
                  href={
                    postData?.AuthorURL && postData?.AuthorURL !== "NA"
                      ? postData?.AuthorURL
                      : ""
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {postData?.AuthorScreenName}
                </a>
              ) : (
                <>{postData?.AuthorScreenName}</>
              )}
            </div>
          </div>
        </div>
        <div className="node-modal-body postCardDetails__body">
          <div className="d-flex align-items-center justify-content-between mb-1">
            {postData?.PlatformID === 1 && !hideHeaderOfCard ? (
              <Tooltip
                title={
                  postData?.FollowersCount
                    ? postData?.FollowersCount?.toLocaleString()
                    : postData?.Followers?.toLocaleString()
                }
              >
                <span className="mr-15 d-flex align-items-center no--wrap">
                  <img
                    src={isDarkBackground ? userFollowersDark : userFollowers}
                    className=" mr-1"
                    alt="userFollowers"
                  />
                  <span className="postCardDetails__footer--label">
                    Followers
                  </span>
                  <span className="postCardDetails__footer--count blue-text">
                    {postData?.FollowersCount
                      ? kFormatter(postData?.FollowersCount)
                      : kFormatter(postData?.Followers)}
                  </span>
                </span>
              </Tooltip>
            ) : (
              ""
            )}

            <Tooltip
              title={
                <div>
                  Created Date : <br /> {postData?.CreatedDate}
                </div>
              }
            >
              <span
                className="d-flex align-items-center"
                style={{ maxWidth: "40%" }}
              >
                <img
                  src={ClockIcon}
                  className="postCardDetails__footer--label mr-1"
                  alt="ClockIcon"
                />
                <span className="postCardDetails__footer--label">
                  {/* {postCardDetails?.CreatedDate} */}
                  {moment(postData?.CreatedDate)?.format("DD MMM YYYY")}
                </span>
              </span>
            </Tooltip>
          </div>
          <div className="postCardDetails--description">
            {postData?.Attachment?.length === 1 ? (
              <div className="m-0 w-100 position-relative postCardDetails--image">
                {postData?.Attachment?.map((imgUrl, index) => {
                  if (imgUrl?.MediaType === "2" || imgUrl?.MediaType === "4") {
                    return imgUrl ? (
                      <>
                        <Image
                          src={imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg}
                          alt="Attachment Image"
                          style={{
                            borderRadius: "0.6rem",
                            objectFit: "cover",
                            height: "20rem",
                          }}
                          onError={onImageError}
                          className="border w-100"
                          fallback={defaultImg}
                          preview={!isImage}
                          placeholder={
                            <Image
                              src={placeHolderImg}
                              preview={false}
                              className="position_relative w-100"
                              style={{
                                borderRadius: "3.2rem",
                                objectFit: "cover",
                                height: "20rem",
                              }}
                            />
                          }
                        />
                      </>
                    ) : (
                      ""
                    );
                  } else if (
                    imgUrl?.MediaType === "3" ||
                    imgUrl?.MediaType === "7"
                  ) {
                    return imgUrl && !PdfDownloadStatus ? (
                      <>
                        {postData?.PlatformID === 2 ||
                        postData?.PlatformID === 4 ||
                        postData?.PlatformID === 37 ? (
                          <a
                            href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Attachment Images"
                              style={{
                                width: "100%",
                                objectFit: "cover",
                                height: "20rem",
                              }}
                              onError={onImageError}
                            />
                            <div class="overlay-play-button__overlay">
                              <div class="overlay-play-button__play">
                                <i
                                  class="fa fa-play"
                                  style={{
                                    fontSize: "1.2rem",
                                    color: "#fff",
                                  }}
                                ></i>
                              </div>
                            </div>
                          </a>
                        ) : postData?.PlatformID === 1 ||
                          postData?.PlatformID === 3 ||
                          postData?.PlatformID === 37 ||
                          postData?.PlatformID === 42 ? (
                          <>
                            <div
                              class="overlay-play-button"
                              style={{ height: "20rem" }}
                              onClick={() => handleVideoPreview(imgUrl)}
                            >
                              <video
                                width="100%"
                                style={{
                                  objectFit: "cover",
                                  height: "20rem",
                                }}
                              >
                                <source
                                  src={
                                    imgUrl?.MediaUrl
                                      ? imgUrl?.MediaUrl
                                      : defaultImg
                                  }
                                  type="video/mp4"
                                />
                              </video>

                              <div class="overlay-play-button__overlay">
                                <div class="overlay-play-button__play">
                                  <i
                                    class="fa fa-play"
                                    style={{
                                      fontSize: "1.2rem",
                                      color: "#fff",
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {/* For Video Preview */}
                        <VideoPreview
                          videoPreview={videoPreview}
                          setIsModalOpen={setIsVideoModalOpen}
                          isModalOpen={isVideoModalOpen}
                          isValidUrlFlag={isValidUrlFlag}
                        />
                      </>
                    ) : PdfDownloadStatus ? (
                      imgUrl && (
                        <img
                          src={imgUrl?.ThumbUrl}
                          alt="Attachment Images"
                          style={{
                            width: "8rem",
                            height: "6.6rem",
                          }}
                          onError={onImageError}
                        />
                      )
                    ) : (
                      ""
                    );
                  }
                })}
              </div>
            ) : (
              postData?.Attachment?.length > 1 && (
                <div className="w-100">
                  <Carousel el={postData} height="20rem" postData={false} />
                </div>
              )
            )}
            {postData?.PostText ? (
              <div
                className={`break-word mb-15 ${
                  postData?.Attachment?.length > 0 ? "mt-2" : ""
                }`}
              >
                {postData?.PostText?.length > 180 ? (
                  <>
                    {postData?.PostText?.length > 180
                      ? postData?.PostText?.slice(0, 180)
                      : postData?.PostText?.length
                      ? postData?.PostText
                      : ""}
                    <span
                      className={`blue-text cursor-pointer postCardReadMoreCC`}
                      onClick={() => showModal(postData)}
                    >
                      ... Read More
                    </span>
                  </>
                ) : (
                  <>{postData?.PostText || postData?.Title}</>
                )}
                {/* <a
                  className={
                    postData?.PostURL &&
                    postData?.PostURL?.trim() &&
                    postData?.PostURL !== "NA"
                      ? ""
                      : "pointer-events1 cursor-default"
                  }
                  href={
                    postData?.PostURL &&
                    postData?.PostURL?.trim() &&
                    postData?.PostURL !== "NA"
                      ? postData?.PostURL
                      : ""
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {postData?.PostText || postData?.Title}
                </a> */}
              </div>
            ) : (
              ""
            )}
            <PostCardFooter
              data={postData}
              isPreviewState={false}
              PdfDownloadStatus={PdfDownloadStatus}
              PptGeneratingStatus={false}
              el={postData}
              postDetail={false}
              isReviewCard={false}
              isNetworkTooltip={true}
              isDarkBackground={isDarkBackground}
            />
            <div className="postCardDetails__footer pt-2 text-center border-top border-color">
              <div className="mr-15" style={{ width: "25%" }}>
                <div className="postCardDetails__footer--label white-space-nowrap">
                  Engagement
                </div>
                <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                  <Tooltip title={postData?.Engagement?.toLocaleString()}>
                    <div>{kFormatter(postData?.Engagement)}</div>
                  </Tooltip>

                  {postData?.PlatformID === 3 && postData?.isPromoted === 5 ? (
                    <Tooltip
                      title={
                        "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                      }
                    >
                      <img
                        src={InfoIconYellow}
                        style={{ maxWidth: "1.5rem" }}
                        className="mr-1 cursor-pointer"
                        alt="info"
                      />
                    </Tooltip>
                  ) : postData?.engagement_fx ? (
                    <Tooltip title={postData?.Engagement_text}>
                      <img
                        src={isDarkBackground ? fxDark : fx}
                        style={{ maxWidth: "1.5rem" }}
                        className="m-auto cursor-pointer"
                        alt="fx"
                      />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
                {/* <Progress
                percent={el?.Engagement}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
              </div>
              <div className="mr-15" style={{ width: "25%" }}>
                <div className="postCardDetails__footer--label white-space-nowrap cursor-pointer">
                  <Tooltip title="Engagement Rate">
                    <div className="white-space-nowrap">Eng. Rate</div>
                  </Tooltip>
                </div>
                <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                  <Tooltip title={postData?.Engagement_rate?.toLocaleString()}>
                    <div>{kFormatter(postData?.Engagement_rate)}</div>
                  </Tooltip>

                  {postData?.Engagement_rate_fx ? (
                    <Tooltip title={postData?.Engagement_rate_text}>
                      <img
                        src={isDarkBackground ? fxDark : fx}
                        style={{ maxWidth: "1.5rem" }}
                        className="m-auto cursor-pointer"
                        alt="fx"
                      />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
                {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
              </div>
              <div className="mr-15" style={{ width: "25%" }}>
                <div
                  className={`postCardDetails__footer--label d-inline-flex align-items-center ${
                    postData?.reach_fx ? "cursor-pointer" : ""
                  }`}
                >
                  {postData?.reach_fx ? (
                    <Tooltip title="Estimated Reach">
                      <div className="white-space-nowrap">Est. Reach</div>
                    </Tooltip>
                  ) : (
                    <div className="white-space-nowrap">Reach</div>
                  )}
                  {postData?.reach_i && (
                    <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                      <img src={InfoIcon} alt="InfoIcon" className="m-auto" />
                    </Tooltip>
                  )}
                </div>
                <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                  <Tooltip title={postData?.Reach?.toLocaleString()}>
                    <div> {kFormatter(postData?.Reach)}</div>
                  </Tooltip>

                  {postData?.reach_fx && (
                    <Tooltip title={postData?.Reach_text}>
                      <img
                        src={isDarkBackground ? fxDark : fx}
                        style={{ maxWidth: "1.5rem" }}
                        className="m-auto cursor-pointer"
                        alt="fx"
                      />
                    </Tooltip>
                  )}
                </div>
                {/* <Progress
                percent={el?.Reach}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
              </div>
              <div style={{ width: "25%" }}>
                {postData?.impression_fx ? (
                  <Tooltip title="Estimated Impression">
                    <div className="postCardDetails__footer--label white-space-nowrap cursor-pointer">
                      {" "}
                      Est. Impression
                    </div>
                  </Tooltip>
                ) : (
                  <div className="postCardDetails__footer--label white-space-nowrap">
                    Impression
                  </div>
                )}
                <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                  <Tooltip title={postData?.Impression?.toLocaleString()}>
                    <div>{kFormatter(postData?.Impression, false, true)}</div>
                  </Tooltip>

                  {postData?.impression_fx && (
                    <Tooltip title={postData?.Impression_text}>
                      <img
                        src={isDarkBackground ? fxDark : fx}
                        style={{ maxWidth: "1.5rem" }}
                        className="m-auto cursor-pointer"
                        alt="fx"
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalData ? (
        <PostCardDetails
          data={postData}
          modalData={modalData}
          isPreviewState={false}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          setIsModalData={setIsModalData}
          isModalLoader={isModalLoader}
          setIsModalLoader={setIsModalLoader}
          isCommandCenterScreen={false}
          el={postData}
          dontShowCustomCard={true}
        />
      ) : (
        ""
      )}
    </>
  );
};
export default React.memo(SinglePostCard, isEqual);
